import route from "@crly/router.js";


/**
 * home
 */
const home = {
    path: '',
    name: 'Home',
    component: () => import('@/views/index')
};

/**
 * contents
 */
const contents = {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('@/layouts/Default'),
    children: [
      // {
      //   path: '',
      //   name: 'トップ：宿泊',
      //   component: () => import('@/views/BS_TOP_01_001'),
      //   meta: {

      //   }
      // },


      {
        path: 'search/map',
        name: 'Search Map',
        component: () => import('@/views/BS_SEARCH_MAP'),
        meta: {
          footer: 'app-02-001'
        }
      },
      {
        path: '/public-stay/menus',
        name: 'Public Stay Menu',
        component: () => import('@/views/PublicStayMenuDetail'),
        children: [
          {
            path: 'register-coupon',
            name: 'BS_APP_02_004_NEW 補助利用申請',
            component: () => import('@/views/PublicStayMenuDetail/BS_APP_02_004_NEW'),
            meta: {
              // footer: 'app-02-001'
              footer: 'men-02-001',
              bs_app: true,
            },
          },
          {
            path: 'register-complete',
            name: 'BS_APP_02_006_NEW',
            component: () => import('@/views/PublicStayMenuDetail/BS_APP_02_006_NEW'),
            meta: {
              // footer: 'app-02-006'
            }
          },
          {
            path: 'register-address',
            name: 'BS_APP_02_002 申込(誰が) - Public stay',
            component: () => import('@/views/PublicStayMenuDetail/BS_APP_02_002_NEW'),
            meta: {
              footer: 'app-02-001',
              onRefesh: {
                confirm: true,
                redirectOnConfirm: 'plan_details',
              },
              bs_app: true,
            }
          },
          {
            path: 'register-confirmation',
            name: 'BS_APP_02_005 申込確認 - Public stay',
            component: () => import('@/views/PublicStayMenuDetail/BS_APP_02_005_NEW'),
            meta: {
              footer: 'app-02-001',
              bs_app: true,
            },
          },
          {
            path: 'article',
            name: 'Menu Article',
            component: () => import('@/views/PublicStayMenuDetail/BS_MYP_10_001_ARTICLE'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' }]
            }
          },
          {
            path: 'register-rooms',
            name: 'BS_APP_02_001_NEW',
            component: () => import('@/views/PublicStayMenuDetail/BS_APP_02_001_NEW'),
            meta: {
              // footer: 'app-02-001'
              bs_app: true,
            }
          },
          {
            path: ':menuNo',
            name: 'Public Menu Detail',
            component: () => import('@/views/PublicStayMenuDetail/MenuDetails'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: '公共の宿', path: '/search/menu' }
              ]
            }
          }
        ]
      },
      {
        path: '/tour/menus',
        name: 'Tour Menu',
        component: () => import('@/views/BookingTour/index'),
        children: [
          {
            path: ':menuNo/plans/:planId',
            name: 'PlanDetail',
            component: () => import('@/views/BookingTour/PlanDetails'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '検索結果', path: '/search/menu' }]
            }
          }
        ]
      },
      {
        path: '/dp/menus',
        name: 'DP Menu',
        component: () => import('@/views/DP/index'),
        children: [
          {
            path: ':menuNo',
            name: 'DpMenuNo',
            component: () => import('@/views/DP/Menus'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '検索結果', path: '/search/menu' }]
            }
          },
          {
            path: ':menuNo/plans',
            name: 'DPPlanList',
            component: () => import('@/views/DP/Menus/PlanList'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '検索結果', path: '/search/menu' }]
            }
          },
          {
            path: ':menuNo/plans/:planId',
            name: 'DpPlanDetail',
            component: () => import('@/views/BookingTour/PlanDetailsDP'),
            meta: {
              requiredLogin: true,
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '検索結果', path: '/search/menu' }]
            }
          }
        ]
      },
      {
        path: '/menus',
        component: () => import('@/views/menu/index'),
        children: [
          {
            path: ':menuNo',
            name: 'Menu Detail',
            component: () => import('@/views/menu/MenuDetails'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: '国内宿泊', path: '/search/menu' }
              ]
            }
          },
          {
            path: ':menuNo/plans',
            name: 'MenuPlanList',
            component: () => import('@/views/menu/PlanList'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: '国内宿泊', path: '/search/menu' }
              ]
            }
          },
          {
            path: ':menuNo/plans/:planId/rooms/:roomId',
            name: 'plan_details',
            component: () => import('@/views/menu/PlanDetails'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: '国内宿泊', path: '/search/menu' }
              ],
              requiredLogin: true
            }
          },
          {
            path: '/menus/:menuNo/photo-gallery',
            name: 'フォトギャラリー/ Photo_Gallery2',
            component: () => import('@/views/menu/PhotoGallery2'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: '国内宿泊', path: '/search/menu' }
              ]
            }
          },
          {
            path: '/menus/:menuNo/gallery',
            name: 'フォトギャラリー/ Photo_Gallery',
            component: () => import('@/views/menu/PhotoGallery'),
            meta: {
              footer: 'men-02-001',
              // 他カテゴリで利用する場合はパンくずタイトルにカテゴリセット必要
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '国内宿泊', path: '/search/menu' }]
            }
          },
          {
            path: '/menus/:menuNo/equipments',
            name: 'メニュー詳細：宿泊設備',
            component: () => import('@/views/menu/EquipmentServices'),
            meta: {
              footer: 'men-02-030',
              // 他カテゴリで利用する場合はパンくずタイトルにカテゴリセット必要
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '国内宿泊', path: '/search/menu' }]
            }
          },
          {
            path: '/menus/:menuNo/reviews',
            name: 'メニュー詳細：宿泊クチコミ',
            component: () => import('@/views/menu/Reviews'),
            meta: {
              footer: 'men-02-030',
              // 他カテゴリで利用する場合はパンくずタイトルにカテゴリセット必要
              breadcrumbs: [{ title: 'トップ', path: '/' },
              { title: '国内宿泊', path: '/search/menu' }]
            }
          }
        ]
      },
      {
        path: 'children-notification',
        name: 'Children Notification',
        component: () => import('@/views/menu/ChildrenNotif')
      },
      {
        path: '/mypage',
        component: () => import('@/layouts/MyPageLayout.vue'),
        children: [
          {
            path: '',
            name: 'mypage',
            component: () => import('@/views/BS_MYP_01_001'),
            meta: {
              loginRequired: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '' }
              ]
            }
          },
          {
            path: 'bs-myp-02-001',
            name: 'クーポン'
          },
          {
            path: 'favorites',
            name: 'BS_MYP_04_001：お気に入り一覧 / list yêu thích',
            component: () => import('@/views/BS_MYP_04_001'),
            meta: {
              loginRequired: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お気に入りリスト', path: '/bs-myp-04-01' }
              ]
            }
          },
          {
            path: 'visits',
            name: 'BS_MYP_03_001：閲覧履歴 / lịch sử xem',
            component: () => import('@/views/BS_MYP_03_001'),
            meta: {
              loginRequired: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み一覧', path: '/mypage/orders' }
              ]
            }
          },
          {
            path: 'orders', // orders
            name: 'BS_MYP_05_001_マイページ：申込履歴一覧/ list history',
            component: () => import('@/views/BS_MYP_05_001'),
            meta: {
              loginRequired: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' }
              ]
            }
          },
          {
            path: 'orders/:orderNo',
            name: 'BS_MYP_05_010_マイページ：申込履歴詳細/application history details (life service)',
            component: () => import('@/views/BS_MYP_05_010'),
            meta: {
              footer: 'men-02-030',
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み履歴', path: '/mypage/orders' }
              ]
            }
          },
          {
            path: 'bs-myp-06-001',
            name: 'クチコミ'
          },
          {
            path: 'setting', //setting
            name: 'BS_SET_02_001 会員プロフィール設定',
            component: () => import('@/views/BS_SET_02_001'),
            meta: {
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' }
              ]
            }
          },
          {
            path: 'coupons',
            name: 'BS_MYP_12_001マイページ：補助クーポン/ Auxiliary coupon',
            component: () => import('@/views/BS_MYP_12_001'),
            meta: {
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: ' マイクーポン ', path: '/mypage/coupons' },
                { title: '', path: '/bs-pnl-02-001' }
              ]
            }
          },
          {
            path: 'coupons/:id',
            name: 'BS_MYP_12_010/coupon detail',
            component: () => import('@/views/BS_MYP_12_001/detail'),
            meta: {
              authenticate: true
            }
          },
          {
            path: 'benepo-history',
            name: 'BS_MYP_07_001マイページ：ベネポ 所持ポイントと利用期限/ point Benepo và thời hạn sử dụng',
            component: () => import('@/views/BS_MYP_07_001'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: ' ベネポの確認 ', path: '' }
              ]
            }
          },
          {
            path: 'benepo-collect',
            name: 'BS_MYP_07_020マイページ：獲得予定のベネポ/ intended to collect Benepo',
            component: () => import('@/views/BS_MYP_07_020'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'ベネポの確認 ', path: '/mypage/benepo-history' },
                { title: '獲得予定のベネポ', path: '/mypage/benepo-collect' }
              ]
            }
          },
          {
            path: 'receipt',
            name: 'BS_MYP_05_020_領収書表示画面',
            component: () => import('@/views/BS_MYP_05_020'),
            meta: {
              footer: 'men-02-030',
              authenticate: true
            }
          },
          {
            path: 'receipt/:acptNo',
            name: '領収書表示画面',
            component: () => import('@/views/BS_MYP_05_020'),
            meta: {
              footer: 'men-02-030',
              authenticate: true
            }
          },
          {
            path: 'cancel-confirmation-information',
            name: 'BS_MYP_05_040_お申し込みキャンセル（内容確認）/ cancel đăng ký (xác nhận nội dung)',
            component: () => import('@/views/BS_MYP_05_040'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み履歴', path: '/mypage/orders' }
              ]
            }
          },
          {
            path: 'cancel-complete',
            name: 'BS_MYP_05_043_お申し込みキャンセル（申請完了）/ cancel đăng ký (hoàn tất đăng ký)',
            component: () => import('@/views/BS_MYP_05_043'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み一覧', path: '/mypage/orders' },
                { title: 'お申し込み情報詳細', path: '/mypage/orders' },
                { title: ' お申し込みキャンセル（申請完了）', path: '' }
              ]
            }
          },
          {
            path: 'cancel-confirmation-payment',
            name: 'BS_MYP_05_041_お申し込みキャンセル（支払方法確認）/ cancel đăng ký ( xác nhận phương thức thanh toán)',
            component: () => import('@/views/BS_MYP_05_041'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み一覧', path: '/mypage/orders' },
                { title: 'お申し込み情報詳細', path: '/mypage/orders' },
                {
                  title: 'お申し込みキャンセル（内容確認）',
                  path: '/mypage/cancel-confirmation-information'
                }
              ]
            }
          },
          {
            path: 'cancel-confirmation-payment/loading',
            name: 'BS_MYP_05_041_お申し込みキャンセル（支払方法確認）- Loading',
            component: () => import('@/views/BS_MYP_05_041_LOADING'),
            meta: {
              authenticate: true,
              breadcrumbs: [
                { title: 'トップ', path: '/' },
                { title: 'マイページ', path: '/mypage' },
                { title: 'お申し込み一覧', path: '/mypage/orders' },
                { title: 'お申し込み情報詳細', path: '/mypage/orders' },
                {
                  title: 'お申し込みキャンセル（内容確認）',
                  path: '/mypage/cancel-confirmation-information'
                }
              ]
            }
          }
        ]
      },
      {
        path: 'register-benepo', // benepo/register
        name: 'BS_APP_02_008_ベネポ利用申請 / Đăng ký sử dụng Benepo',
        component: () => import('@/views/BS_APP_02_008')
      },
      {
        path: 'register-rooms',
        name: 'BS_APP_02_001 申込(何を・どこに)',
        component: () => import('@/views/BS_APP_02_001'),
        meta: {
          footer: 'app-02-001',
          onRefesh: {
            confirm: true,
            redirectOnConfirm: 'plan_details'
          },
          bs_app: true,
        }
      },
      {
        path: 'register-address',
        name: 'BS_APP_02_002 申込(誰が)',
        component: () => import('@/views/BS_APP_02_002'),
        meta: {
          footer: 'app-02-001',
          onRefesh: {
            confirm: true,
            redirectOnConfirm: 'plan_details'
          },
          bs_app: true,
        }
      },
      {
        path: 'register-coupon',
        name: 'BS_APP_02_002 補助クーポン申請',
        component: () => import('@/views/BS_APP_02_004'),
        meta: {
          // footer: 'app-02-001'
          footer: 'men-02-001',
          bs_app: true,
        },
      },
      {
        path: 'register-confirmation',
        name: 'BS_APP_02_005 申込確認',
        component: () => import('@/views/BS_APP_02_005'),
        meta: {
          footer: 'app-02-001',
          onRefesh: {
            confirm: true,
            redirectOnConfirm: 'plan_details'
          },
          bs_app: true,
        }
      },
      {
        path: 'orders/confirm',
        name: 'BS_APP_02_005 申込確認 / 事前決済',
        redirect: () => {
          const beforeQuery = JSON.parse(sessionStorage.getItem('confirmQuery')) ?? {}
          return{
            path : 'register-confirmation',
            query: beforeQuery
          }
        }
      },
      {
        path: 'register-confirmation/loading',
        name: 'BS_APP_02_005_2 申込確認',
        component: () => import('@/views/BS_APP_02_005_2'),
        meta: {
          footer: 'app-02-001'
        }
      },
      {
        path: 'register-complete',
        name: 'BS_APP_02_006_申込完了ページ / Page hoàn tất đăng ký',
        component: () => import('@/views/BS_APP_02_006/index.vue')
      },
      {
        path: 'orders/complete',
        name: 'BS_APP_02_006_申込完了ページ / 事前決済',
        redirect: (to) => {
          const beforeQuery = JSON.parse(sessionStorage.getItem('confirmQuery')) ?? {}
          const query = Object.assign(beforeQuery, to.query)
          return{
            path : 'register-complete',
            query: query
          }
        }
      },
      {
        path: 'register-attention',
        name: 'BS_MYP_10_001_個人情報取扱注意 / Chú ý khi sử dụng thông tin cá nhân',
        component: () => import('@/views/BS_MYP_10_001')
      },

      {
        path: 'notifications',
        name: 'BS_INF_01_001_お知らせ一覧/ list notification Life',
        component: () => import('@/views/BS-INF-01-001'),
        meta: {
          breadcrumbs: [{ title: 'トップ', path: '/' }]
        }
      },
      {
        path: 'notifications/:id',
        name: 'BS_INF_01_010/ detail notification Life',
        component: () => import('@/views/BS-INF-01-001/detail'),
        meta: {
          breadcrumbs: [
            { title: 'トップ', path: '/' },
            { title: 'お知らせ一覧', path: '/notifications' },
            { title: '', path: '' }
          ]
        }
      },
      {
        path: 'low-price', // low-price
        name: 'BS_APP_03_001_ロープライスギャランティ申請 / đăng ký low price guarantee',
        component: () => import('@/views/BS_APP_03_001')
      },
      {
        path: 'low-price-term',
        name: 'BS_APP_03_002 term ',
        component: () => import('@/views/BS_APP_03_002_Term')
      },
      {
        path: 'bs-app-02-003',
        name: 'BS_APP_02_003_申込(同行者申請) / đăng ký (đăng ký người đi cùng)',
        component: () => import('@/views/BS_APP_02_003')
      },
      {
        path: 'low-price-complete',
        name: 'BS_APP_03_003_ロープライスギャランティ申請/ hoàn thành đăng ký low price guarantee',
        component: () => import('@/views/BS_APP_03_003')
      },
      {
        path: 'low-price-confirm',
        name: 'BS_APP _03_002_ロープライスギャランティ申請/ xác nhận đăng ký low price ',
        component: () => import('@/views/BS_APP_03_002'),
        meta: {}
      },
      {
        path: 'bs-spe-01-001', // special-list
        name: 'BS_SPE_01_001_特集一覧 /Danh sách đặc biệt',
        component: () => import('@/views/BS_SPE_01_001'),
        meta: {
          breadcrumbs: [
            { title: 'トップ', path: '/' },
            { title: '特集一覧', path: '/bs-spe-01-001' }
          ]
        }
      },
      // {
      //   path: 'bs-01-010',
      //   name: 'BS_SPE_01_010_特集ページ',
      //   component: () => import('@/views/BS_01-010'),
      //   meta: {
      //     breadcrumbs: [
      //       { title: 'トップ', path: '/' },
      //       { title: '特集一覧', path: '/bs-spe-01-001' },
      //       { title: '', path: '/bs-01-010' }
      //     ]
      //   }
      // },
      {
        path: 'special', // special-page
        name: 'BS_SPE_01_010_特集ページ/ Page đặc biệt',
        component: () => import('@/views/BS_01-010'),
        meta: {
          footer: 'men-02-001',
          breadcrumbs: [
            { title: 'トップ', path: '/' },
            { title: '特集一覧', path: '/special-page' }
          ]
        }
      },
      /*
      {
        path: 'bs-men-02-010',
        name: 'BS_MEN_02_010_プラン一覧',
        component: () => import('@/views/menu/BS_02_010'),
        meta: {
          header: 'men-02-010',
          footer: 'men-02-001'
        }
      },
      */
      {
        path: '/search/plan',
        component: () => import('@/views/menu/BS_02_010'),
        children: [
          {
            path: ':menuNo',
            name: 'BS_MEN_02_010_プラン一覧 - Search Plans',
            component: () => import('@/views/menu/BS_02_010'),
            meta: {
              footer: 'men-02-001',
              breadcrumbs: [{ title: 'トップ', path: '/' }]
            }
          }
        ]
      },
      {
        path: 'bs-men-02-020',
        name: 'BS_MEN_02_020_フォトギャラリー',
        component: () => import('@/views/menu/BS_MEN_02_020'),
        meta: {
          footer: 'men-02-001',
          breadcrumbs: [
            { title: 'トップ', path: '/' },
            { title: '', path: '/bs-men-02-020' }
          ]
        }
      },
      {
        path: 'bs-pnl-02-001',
        name: 'BS_PLN_02_001_プラン詳細：宿泊',
        component: () => import('@/views/plan/BS_PLN_02_001'),
        meta: {
          footer: 'men-02-001',
          breadcrumbs: [
            { title: 'トップ', path: '/' },
            { title: '', path: '/bs-pnl-02-001' }
          ]
        }
      },
      // {
      //   path: 'bs-pnl-02-001/menus/:menu_id/plans/:plan_id/rooms/:room_id/stay?companyCd=102461',
      //   name: 'BS_PLN_02_001_プラン詳細：宿泊_1',
      //   component: () => import('@/views/plan/BS_PLN_02_001'),
      //   meta: {
      //     header: 'pnl-02-001',
      //     footer: 'men-02-001'
      //   }
      // },
      {
        path: 'bs-02-001',
        name: 'BS_MEN_02_001_メニュー詳細：宿泊トップ / Menu Detail',
        component: () => import('@/views/menu/BS_02_001'),
        meta: {
          footer: 'men-02-001',
          breadcrumbs: [{ title: 'トップ', path: '/' }]
        }
      },
      {
        path: 'bs-men-05-010',
        name: 'BS_MEN_05_010',
        component: () => import('@/views/menu/BS_MEN_05_010'),
        meta: {
          breadcrumbs: []
        }
      },
      {
        path: 'popup-add',
        name: 'マイリストに追加を選択した際の表示/ Hiển thị khi bạn chọn thêm vào danh sách của tôi',
        component: () => import('@/views/PopUpSelectAdd')
      },
      {
        path: 'popup-room-details',
        name: 'モーダル：お部屋の詳細（モーダル内スクロール）/ Hiển thị khi bạn chọn xem chi tiết phòng',
        component: () => import('@/views/PopUpRoomDetails')
      },
      {
        path: 'bs-oth-01-001',
        name: 'BS_OTH_01_001_フィードバック/ feedback',
        component: () => import('@/views/POPUP/BS-OTH-01-001')
      },
      {
        path: 'bs-inf_01_010',
        name: 'BS_INF_01_010_お知らせ詳細/ detail notification',
        component: () => import('@/views/BS_INF_01_010'),
        meta: {
          loginRequired: true
        }
      },
      {
        path: 'bs-oth-02-001',
        name: 'BS_OTH_02_001_アカウント選択/Chọn account',
        component: () => import('@/views/BS_OTH_02_001')
      },
      // {
      //   path: 'instruct_login1',
      //   name: 'BS_OTH_03_001_ログイン誘導モーダル/ Modal hướng dẫn login_page1',
      //   component: () => import('@/views/BS_OTH_03_001/InstructionLogin1/InstructionLogin1.vue')
      // },
      // {
      //   path: 'instruct_login3',
      //   name: 'BS_OTH_03_001_ログイン誘導モーダル/ Modal hướng dẫn login_page3',
      //   component: () => import('@/views/BS_OTH_03_001/InstructionLogin3/InstructionLogin3.vue')
      // },
      {
        path: 'bs-top-01-001',
        name: 'BS_TOP_01_001 トップ：宿泊',
        component: () => import('@/views/BS_TOP_01_001'),
        meta: {}
      },
      {
        path: 'bs-set-02-003',
        name: 'BS_SET_02_003 会員プロフィール設定（お気に入りエリア：モー',
        component: () => import('@/views/BS_SET_02_003')
      },
      {
        path: 'bs-men-02-030',
        name: 'BS_MEN_02_030 メニュー詳細：宿泊設備',
        component: () => import('@/views/menu/BS_MEN_02_030'),
        meta: {
          footer: 'men-02-030',
          breadcrumbs: [{ title: 'トップ', path: '/' }, { title: '横浜ベイホテル東急' }]
        }
      },
      /*
      {
        path: 'bs_sch_03_001',
        name: 'BS_SCH_03_001 メニュー検索結果一覧（宿泊）_（サイドバー開いている）',
        component: () => import('@/views/search/BS_SCH_03_001')
      },
      */
      {
        path: '/search/menu',
        component: () => import('@/views/search/BS_SCH_03_001'),
        meta: {
          breadcrumbs: [{ title: 'トップ', path: '/' }]
        },
        children: [
          {
            path: ':keyword',
            name: 'BS_SCH_03_001 メニュー検索結果一覧（宿泊）_（サイドバー開いている）',
            component: () => import('@/views/search/BS_SCH_03_001'),
            props: true,
            meta: {
              footer: 'men-02-001'
            }
          }
        ]
      },
      {
        path: 'bs-set-02-003-interest',
        name: 'BS_SET_02_003_INTEREST',
        component: () => import('@/views/BS_SET_02_003_INTEREST')
      },
      {
        path: 'bs-men-02-040',
        name: 'BS_MEN_02_040 メニュー詳細：宿泊クチコミ',
        component: () => import('@/views/menu/BS_MEN_02_040'),
        meta: {
          footer: 'men-02-030'
        }
      },
      {
        path: 'modal-commit-condition',
        name: ' MODAL モーダル：空き室カレンダー（モーダル内スクロール）',
        component: () => import('@/views/Modal_commit')
      },
      {
        path: 'ChildrenAttach',
        name: 'モーダル：人数・部屋数（モーダル内スクロール）',
        component: () => import('@/views/ChildrenAttach')
      },
      {
        path: 'modal-datepciker',
        name: 'Modal-DatePicker',
        component: () => import('@/views/Modal-Datepicker')
      },
      {
        // お気に入り
        path: "/favorite",
        name: "CrlyFavorite",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_TOP_DOMAIN}/favorite`;
        }
      },
      {
        // マイページ
        path: "/mypage",
        name: "MyPage",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage`;
        }
      },
      {
        // 会員証ページ
        path: "/mypage/coupon/member?sort=getCouponDatetime",
        name: "MypageMembershipPass",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/coupon/member?sort=getCouponDatetime`;
        }
      },
      {
        // ご利用履歴（申し込み履歴）
        path: "/mypage/orders?page=1&sortOrder=desc",
        name: "MypageOrders",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/orders?page=1&sortOrder=desc`;
        }
      },
      {
        // ベネポの確認
        path: "/mypage/benepo",
        name: "MypageBenepo",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/benepo`;
        }
      },
      {
        // 個人設定
        path: "/mypage/setting",
        name: "MypageSetting",
        beforeEnter() {
          window.location = `${process.env.VUE_APP_MYPAGE_DOMAIN}/mypage/setting`;
        }
      },
      // ================================
      // error
      // ================================
      {
        path: '/*maintenance',
        name: 'maintenance',
        component: () => import('@/views/pages/maintenance.vue'),
        meta: {
          page: {
            title: 'maintenance',
            name: 'maintenance'
          },
          breadcrumbs: [],
          isShowHeaderContent: false,
          isShowFooterContent: false
        }
      },
      {
        path: '/404',
        name: '404Error',
        component: () => import('@/views/pages/error_404.vue'),
        meta: {
          page: {
            title: '404Error',
            name: '404Error'
          },
          breadcrumbs: []
        }
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('@/views/pages/error.vue'),
        meta: {
          page: {
            title: 'errorDefault',
            name: 'errorDefault'
          },
          breadcrumbs: [],
          isShowHeaderContent: false,
          isShowFooterContent: false
        }
      },
      {
        path: '/session-time-out',
        name: 'sessionTimeOut',
        component: () => import('@/views/pages/error_session.vue'),
        meta: {
          page: {
            title: 'sessionTimeOut',
            name: 'sessionTimeOut'
          },
          breadcrumbs: [],
          isShowHeaderContent: false,
          isShowFooterContent: false
        }
      },
      // CRMとBS両方を残した
      // 理由：BSの追加分を取り込む必要があるため、またライフエール独自の対応を行う必要があるため。
      {
        path: "/session-time-out-to-top",
        name: "sessionTimeOutToTop",
        component: () => import("@/views/pages/error_session_to_top.vue"),
        meta: {
          page: {
            title: "sessionTimeOut",
            name: "sessionTimeOut"
          },
          breadcrumbs: [],
          isShowHeaderContent: false,
          isShowFooterContent: false
        }
      },
      {
        path: "/authorization/error-contract-0002",
        name: "error-contract-0002",
        component: () => import("@/views/pages/BSContractError0002.vue"),
        meta: {
          page: {
            title: "errorPreMembership",
            name: "errorPreMembership"
          },
          isShowHeaderContent: false
        }
      },
      {
        path: "/authorization/error-contract-0003",
        name: "error-contract-0003",
        component: () => import("@/views/pages/BSContractError0003.vue"),
        meta: {
          page: {
            title: "errorCanceledMembership",
            name: "errorCanceledMembership"
          },
          isShowHeaderContent: false
        }
      },
      {
        path: "/authorization/error-contract-0004",
        name: "error-contract-0004",
        component: () => import("@/views/pages/BSContractError0004.vue"),
        meta: {
          page: {
            title: "errorOutOfContract",
            name: "errorOutOfContract"
          },
          isShowHeaderContent: false
        }
      },
      {
        path: "/authorization/error-contract-0006",
        name: "error-contract-0006",
        component: () => import("@/views/pages/BSContractError0006.vue"),
        meta: {
          page: {
            title: "errorUnexpected",
            name: "errorUnexpected"
          },
          isShowHeaderContent: false
        }
      },
      {
        path: "/authorization/error-contract-0008",
        name: "error-contract-0008",
        component: () => import("@/views/pages/BSContractError0008.vue"),
        meta: {
          page: {
            title: "errorCrmMember",
            name: "errorCrmMember"
          },
          isShowHeaderContent: false
        }
      },
      {
        path: "/interrupt",
        name: "interrupt",
        component: () => import("@/views/pages/error_interrupt.vue"),
        meta: {
          page: {
            title: "interrupt",
            name: "interrupt"
          },
          isShowHeaderContent: false
        }
      },
      //ライフエール独自対応 ↓↓↓↓
      {
        //エラー画面：混線エラー
        path: '/line-busy-error',
        name: 'CrlyLineBusyError',
        component: () => import('@/components/LifeYell/components/organisms/error/ErrorMsgUser.vue'),
      },
      {
        // 未加入メッセージ
        path: "/not-member",
        name: "CrlyNotMember",
        component: () =>import('@/components/LifeYell/components/organisms/error/ErrorNotMember.vue'),
        props: {
          type: "notMember"
        }
      },
      {
        // 入会確認画面
        path: "/entry",
        name: "CrlyEntry",
        component: () => import("@/components/LifeYell/views/Entry.vue")
      },
      //ライフエール独自対応 ↑↑↑↑
    ]
  };

  // Fullpage
  const fullPage = {
    path: '/pages',
    component: () => import('@/layouts/NoValid'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: 'unauthorized',
        name: 'Error Page Not Authorized',
        component: () => import('@/views/pages/Unauthorized.vue')
      },
      {
        path: 'not-found',
        name: 'Error Page 404',
        component: () => import('@/views/pages/Error404.vue')
      },
      {
        path: 'internal-error',
        name: 'Error Page 500',
        component: () => import('@/views/pages/Error500.vue')
      },
      {
        path: 'page-error',
        name: 'Error Page Not Found',
        component: () => import('@/views/pages/ErrorNotFound.vue')
      },
      {
        path: 'no-valid-plan-menu',
        name: 'Error Page No Valid',
        component: () => import('@/views/pages/ErrorUnauthorized.vue')
      },
      {
        path: 'error-public-stay',
        name: 'Error Page Not Public',
        component: () => import('@/views/pages/ErrorPublicStay.vue')
      },
    ],
  };
  //ライフエール独自対応 ↓↓↓↓
  const lifeYellFullPage1 = {
    // エラー画面：機種エラー（ガラケーなど）
    path: "/device-error",
    name: "CrlyErrorMsgDevice",
    component: () => import('@/components/LifeYell/components/organisms/error/ErrorMsgDevice.vue'),
  };

  const lifeYellFullPage2 = {
    // エラー画面：システムエラー
    path: "/system-error",
    name: "CrlyErrorMsgSystem",
    component: () => import('@/components/LifeYell/components/organisms/error/ErrorMsgSystem.vue'),
  };
  //ライフエール独自対応 ↑↑↑↑

  // ================================
  // callback
  // ================================
  const authorizationCb = {
    path: '/authorization/cb',
    name: 'callback',
    // ライフエール独自対応
    // component: () => import('@/views/auth/index.vue')
    component: () => import('@crly/views/auth/Index.vue')
  };
  const screens = {
    path: '/screens',
    name: 'screens',
    component: () => import('@/views/Home')
  };
  const redirect = {
    path: '/*',
    // redirect: '/404',
    beforeEnter() {
      window.location = '/404'
    }
  };
  // Redirect to 404 page, if no match found
  const redirect404 = {
    path: '*',
    component: () => import('@/views/pages/Error404.vue')
  };


// ルーティングリスト
  //ライフエール独自対応 ↓↓↓↓
  // let routes = [home, contents,fullPage,authorizationCb,screens,redirect,redirect404];
  let routes = [home, contents,fullPage, lifeYellFullPage1, lifeYellFullPage2, authorizationCb,screens,redirect,redirect404];
  //ライフエール独自対応 ↑↑↑↑
  for (var i = 0; i < route.length; i++) {
  routes.push(route[i]);
}

export default routes;
